export default "__VITE_ASSET__BCYIUx$S__"